import { render, staticRenderFns } from "./BackTopButton.vue?vue&type=template&id=6d9bd828&scoped=true"
import script from "./BackTopButton.vue?vue&type=script&lang=js"
export * from "./BackTopButton.vue?vue&type=script&lang=js"
import style0 from "./BackTopButton.vue?vue&type=style&index=0&id=6d9bd828&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9bd828",
  null
  
)

export default component.exports